import { UnstyledButton } from '@mantine/core';
import { ReactNode } from 'react';

import classes from './StatisticLink.module.css';

interface StatisticLinkProps {
  isCompleted?: boolean;
  disabled?: boolean;
  'data-pw'?: string;
  onClick?: () => void;
  children: ReactNode;
}

export const StatisticLink: React.FC<StatisticLinkProps> = ({ isCompleted, disabled, onClick, children, ...props }) => {
  return (
    <UnstyledButton
      className={`${classes.statisticLink} ${disabled ? classes.disabled : classes.notDisabled} ${isCompleted ? classes.completed : classes.notCompleted}`}
      onClick={onClick}
      data-pw={props['data-pw']}
    >
      {children}
    </UnstyledButton>
  );
};
